module.exports = __webpack_public_path__ + "img/check-icon.4df553e0.svg";